import config from '@config'
import useABTestValue from '@hooks/useABTestValue'
import useFeatureFlagsSkeleton from '@hooks/useFeatureFlagsSkeleton'

import useEnableEnhancedSearchPage from './useEnableEnhancedSearchPage'

export type UseIsCUIEnabled = () => boolean

const {
  backend: { teamcityEnv },
  publication: { publication },
} = config

const useIsCUIEnabled: UseIsCUIEnabled = () =>
  [
    publication !== 'romandie',
    useFeatureFlagsSkeleton()?.isChatbotEnabled,
    useABTestValue('showCUI') === 'show' || !['prod'].includes(teamcityEnv),
    !useEnableEnhancedSearchPage(),
  ].every(Boolean)

export default useIsCUIEnabled
